import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'ng2-file-upload';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ComumModule } from './../../shared/comum.module';
import { translateLoaderNBS } from './../../shared/translate-loader/translateLoader';
import { ComunicadoComponent } from './comunicado.component';
import { ExibirComponent } from './exibir/exibir.component';
import { ListaComponent } from './lista/lista.component';
import { NovoComponent } from './novo/novo.component';
import { ComunicadoService } from './service/comunicado.service';
import { AsciiOnlyDirective } from './directives/ascii-only.directive';


@NgModule({
  declarations: [
    ComunicadoComponent,
    ListaComponent,
    NovoComponent,
    ExibirComponent,
    AsciiOnlyDirective
  ],
  imports: [
    BrowserModule,
    ComumModule,
    HttpModule,
    FormsModule,
    FileUploadModule,
    DropdownModule,
    InputTextModule,
    CalendarModule,
    DialogModule,
    ButtonModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  providers: [
    ComunicadoService
  ],
  bootstrap: [
    ComunicadoComponent
  ]
})
export class ComunicadoModule { }
